import { useMemo } from "react";
import Particles from "react-tsparticles";

function ParticlesBg({ className = "app-bg" }) {
  const options = useMemo(
    () => ({
      background: { color: "#001f3f" },
      particles: {
        number: { value: 120 },
        color: { value: "#dddddd" },
        opacity: { value: 0.55 },
        links: { enable: true, color: "#dddddd", opacity: 0.25 },
        move: { enable: true, speed: 1 },
      },
      interactivity: {
        events: {
          onClick: { enable: false },
          onHover: { enable: false },
        },
      },
    }),
    []
  );

  return (
    <div
      className={className}
      aria-hidden
      style={{
        position: "fixed",
        inset: 0,
        zIndex: -1,
        pointerEvents: "none"
      }}
    >
      <Particles
        id="tsparticles"
        options={options}
        style={{ pointerEvents: "none" }}
      />
    </div>
  );
}

export default ParticlesBg;